import { type ComponentProps } from "react";

export const Video = (props: ComponentProps<"iframe">) => {
  return (
    <iframe
      title="Embeeded Video"
      height={500}
      width="100%"
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      {...props}
    />
  );
};
